import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import Slider from "react-slick";
function NationalActive() {
  const settings = {
    arrows: false,
    dots: false,
    pauseOnHover: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    variableWidth: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>Xalqaro faoliyat</h4>
            </div>
            <p>
              Institutning “O‘zbek tili va adabiyoti” kafedrasi mudiri
              Abdullaeva Albina Ergashevna Amerika Qo‘shma Shtatlarining Arizona
              shtatidagi Arizona universitetiga 29-yanvardan 20-fevralga qadar
              (144 soatlik) malaka oshirdi.{" "}
            </p>
          </div>
          <Slider {...settings}>
            <div>
              <div className="card5__custom">
                <img src="/img/s1.jpg" alt />
                <img src="/img/s2.jpg" alt />
                <img src="/img/s3.jpg" alt />
              </div>
            </div>
            <div>
              <div className="card5__custom">
                <img src="/img/5.png" alt />
                <img src="/img/5.png" alt />
                <img src="/img/5.png" alt />
              </div>
            </div>
            <div>
              <div className="card5__custom">
                <img src="img/5.png" alt />
                <img src="img/5.png" alt />
                <img src="img/5.png" alt />
              </div>
            </div>
          </Slider>

          <br />
          <br />
          <p>
            Institutning Amaliyot ishlari bo‘yicha prorektori Ganieva Xilola
            Gayratovna hamda Xalqaro hamkorlik boʼlimi boshligʼi Alijonova
            Komila Toxir qizi 2022-yilning 20-martdan 3-aprelga qadar Vengriya
            Respublikasining Debretsen shahrida joylashgan “Debrecen University”
            ga xizmat safariga yuborilildi. Ganieva Xilola Gayratovna Debretsen
            universitetida ma’ruza va seminar o‘tkazdi.
          </p>
        </div>
      </div>
      <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default NationalActive;
